import { BaseModifier } from "./base-modifier";
export class TinymceModifier extends BaseModifier {
    constructor() {
        super(".tinymce");
        this.nextImageId = 1;
        this.images = {};
    }
    prepareValue(formData, name) {
        return new Promise((resolve, reject) => {
            const tinymce = this.input.jQueryObject.tinymce();
            const cleanContent = tinymce.getContent();
            const promiseUploadImages = tinymce.uploadImages();
            promiseUploadImages.then(() => {
                const preparedContent = tinymce.getContent();
                tinymce.setContent(cleanContent);
                formData.set(name, preparedContent);
                this.addImages(formData);
                resolve();
            });
            promiseUploadImages.catch((value) => reject(value));
        });
    }
    addImages(formData) {
        for (const name in this.images) {
            if (!this.images.hasOwnProperty(name)) {
                continue;
            }
            formData.set(name, this.images[name]);
        }
    }
    initialize() {
        $(this.input.domElement).tinymce({
            height: 500,
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks advcode fullscreen autosave emoticons",
                "insertdatetime media table powerpaste hr code",
            ],
            default_link_target: "_blank",
            autosave_interval: "20s",
            autosave_retention: "60m",
            toolbar_mode: "floating",
            powerpaste_allow_local_images: true,
            powerpaste_word_import: "prompt",
            powerpaste_html_import: "prompt",
            toolbar: "insertfile undo redo restoredraft | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | emoticons",
            content_css: ["//fonts.googleapis.com/css?family=Lato:300,300i,400,400i"],
            paste_data_images: true,
            automatic_uploads: false,
            images_upload_handler: (blobInfo, success, failure) => {
                this.processImage(blobInfo.blob(), success);
            },
            convert_urls: false,
            image_advtab: true,
        });
    }
    processImage(blob, success) {
        const name = `##img-tmp${this.nextImageId++}##`;
        this.images[name] = blob;
        success(name);
    }
}
